import React from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'

const StBars = styled.div`
  display: flex;
  width: 100%;
  color: white;
  overflow: hidden;
`

const StAprueboRechazo = styled.div`
  background-color: white;
`

const StBarApruebo = styled.div`
  background-color: #3e8fe1;
  height: 12px;
`

const StBarRechazo = styled.div`
  background: #e15724;
  height: 12px;
`

const StCifras = styled.div`
  ${tw`font-sans flex  justify-between`}
  width: 100%;
  .ttl-apruebo {
    color: #3e8fe1;
    small {
      text-align: left;
    }
  }
  .ttl-rechazo {
    color: #e15724;
    small {
      text-align: right;
    }
  }
  small {
    ${tw`font-sans text-lg block`}
    letter-spacing: 0px;
  }
`

const Bars = ({ apruebo, rechazo }) => {
  return (
    <StAprueboRechazo>
      <StCifras>
        <h2 className="leading-none ttl-apruebo">
          {apruebo}% <small>Apruebo</small>
        </h2>
        <h2 className="leading-none ttl-rechazo">
          {rechazo}% <small>Rechazo</small>
        </h2>
      </StCifras>
      <StBars>
        <StBarApruebo style={{ width: `${apruebo}%` }}></StBarApruebo>
        <StBarRechazo style={{ width: `${rechazo}%` }}></StBarRechazo>
      </StBars>
    </StAprueboRechazo>
  )
}

const AprueboRechazo = ({ apruebo, rechazo }) => {
  return (
    <div>
      {apruebo >= rechazo ? (
        <div>
          <h2 className="text-6xl">¡Aprueba!</h2>
          <Bars apruebo={apruebo} rechazo={rechazo} />
        </div>
      ) : (
        <div>
          <h2 className="text-6xl">¡Rechaza!</h2>
          <Bars apruebo={apruebo} rechazo={rechazo} />
        </div>
      )}
    </div>
  )
}

export default AprueboRechazo
